export var Environment;
(function (Environment) {
    Environment["HOSPITALITY"] = "HOSPITALITY";
    Environment["INTEGRATION"] = "INTEGRATION";
    Environment["PORTAL"] = "PORTAL";
    Environment["B2B"] = "B2B";
})(Environment || (Environment = {}));
export const getEnvironmentAsString = (environment) => {
    switch (environment) {
        case Environment.HOSPITALITY:
            return 'Hospitality';
        case Environment.INTEGRATION:
            return 'Integration';
        case Environment.PORTAL:
            return 'Portal';
        case Environment.B2B:
            return 'B2B';
        default:
            return environment;
    }
};
